import { render, staticRenderFns } from "./r-item-touch-action.vue?vue&type=template&id=52ab5c72"
import script from "./r-item-touch-action.vue?vue&type=script&lang=js"
export * from "./r-item-touch-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ab5c72')) {
      api.createRecord('52ab5c72', component.options)
    } else {
      api.reload('52ab5c72', component.options)
    }
    module.hot.accept("./r-item-touch-action.vue?vue&type=template&id=52ab5c72", function () {
      api.rerender('52ab5c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/touch/r-item-touch-action.vue"
export default component.exports